import { Fragment, useEffect, useState } from "react";
import enUS from "date-fns/locale/en-US";
import {
  startOfWeek,
  addDays,
  format,
  eachMinuteOfInterval,
  isToday,
  endOfDay,
  startOfDay,
  addMinutes,
  set,
} from "date-fns";

import { calcCellHeight, calcMinuteHeight, convertToJSDate } from "../helpers/genrrals";
import TodayTypo from "./TodayType";
import Cell from "./Cell";
import TodayEvents from "./TodayEvents";
import TodayBreaks from "./TodayBreaks";
import _ from "lodash"
import moment from "moment";
import { AppConstant } from "../../../../Assests/AppConstant";
import Hour from "./Hour";

const Week = ({dateSelected,events,startHour=0,endHour=24,breakList,showScheduleModal,setShowScheduleModal,selectedDock,leaveList,dockList,dockOperationalDays,whMetaDocksList}) => {
  const [dockLeavesList,setDockLeavesList] = useState([]);
  const direction = "ltr";
  const height = 600;
  const locale = enUS;
  const selectedDate = new Date(dateSelected);
  const weekStartOn = 0;
  const weekDays = [0, 1, 2, 3, 4, 5, 6];
  const hourFormat = "12";
  const step = 60;
  const _weekStart = startOfWeek(selectedDate, { weekStartsOn: weekStartOn });
  const daysList = weekDays.map((d) => addDays(_weekStart, d));
  const weekStart = startOfDay(daysList[0]);
  const weekEnd = endOfDay(daysList[daysList.length - 1]);
  const START_TIME = set(selectedDate, {
    hours: startHour,
    minutes: 0,
    seconds: 0,
  });
  const END_TIME = set(selectedDate, {
    hours: endHour,
    minutes: -step,
    seconds: 0,
  });
  
  const hours = eachMinuteOfInterval(
    {
      start: START_TIME,
      end: END_TIME,
    },
    { step }
  );
  const CELL_HEIGHT = calcCellHeight(height, hours.length);
  const MINUTE_HEIGHT = calcMinuteHeight(CELL_HEIGHT, step);
  const hFormat = hourFormat === "12" ? "hh:mm a" : "HH:mm";

  /**
   * Function to get non operational day
   * @param {*} date 
   * @returns 
   */
  const getNonOperationalDay=(date)=>{
    let isNonOperational=false
    const todaysDay=format(date, "eeee", { locale }).toLowerCase().toString();
    if (selectedDock && selectedDock.length && selectedDock[0].dockId!=="0000") {
        if (!selectedDock[0][todaysDay]) {
          isNonOperational=true
        }else{
          isNonOperational=false
        }
    }
    else{
      isNonOperational=false
    }
    return isNonOperational
  }


  const getDockColorByID=(id)=>{
    if (dockList && dockList.length) {
      const dock = dockList.filter((el)=>el.dockId === id)
      if (dock && dock.length) {
        return dock[0].dockColor
      }
    }
  }

  /**
   * useEffect to filter leaves based on selected dock
   */
  useEffect(()=>{
    let finalLeaves = []
    if (leaveList && leaveList.length) {
       leaveList.forEach((el)=>{
        if (el.Status) {
            let obj={
      ...el,
      dockColor:getDockColorByID(el.IDDock)
     }
     finalLeaves.push(obj)
        }
   
    })
    }
   
    if (selectedDock && finalLeaves.length) {
      const dockLeaves=finalLeaves.filter((el)=>el.IDDock===selectedDock[0].dockId && el.Status)
      setDockLeavesList(dockLeaves)
    }else{
      setDockLeavesList(finalLeaves)
    }
   
  },[selectedDock,leaveList,dockList])


  const getBreaksForDay = (date) => {
    if (!breakList || !breakList.length) return [];
    
    const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayOfWeek = dayNames[date.getDay()];
    
    const dateString = moment(date).format('YYYY-MM-DD');
    
    const daysBreaks = breakList.filter(breakItem => {
      if (breakItem[dayOfWeek] !== true) return false;
      
      const breakStartMoment = moment.utc(breakItem.BreakStart);
      const breakEndMoment = moment.utc(breakItem.BreakEnd);
      
      const dateAtMidnight = moment.utc(dateString).startOf('day');
      const dateAtEndOfDay = moment.utc(dateString).endOf('day');
      
      const breakStartsBeforeEndOfDay = breakStartMoment.isBefore(dateAtEndOfDay) || breakStartMoment.isSame(dateAtEndOfDay);
      const breakEndsAfterStartOfDay = breakEndMoment.isAfter(dateAtMidnight) || breakEndMoment.isSame(dateAtMidnight);
      
      if (!breakStartsBeforeEndOfDay || !breakEndsAfterStartOfDay) {
        return false;
      }
      
      if (selectedDock && selectedDock.length && selectedDock[0].dockId !== "0000") {
        if (breakItem.IDDock !== selectedDock[0].dockId) return false;
      }
      
      return true;
    });

    const formattedBreaks = daysBreaks.map(breakItem => {
      const breakStartMoment = moment.utc(breakItem.BreakStart);
      const breakEndMoment = moment.utc(breakItem.BreakEnd);
      
      const startDate = new Date(date);
      startDate.setHours(breakStartMoment.hours(), breakStartMoment.minutes(), breakStartMoment.seconds(), 0);
      
      const endDate = new Date(date);
      endDate.setHours(breakEndMoment.hours(), breakEndMoment.minutes(), breakEndMoment.seconds(), 0);

      if (endDate < startDate) {
        endDate.setDate(endDate.getDate() + 1);
      }

      const dockInfo = dockList?.find(d => d.dockId === breakItem.IDDock) || {};

      return {
        ...breakItem,
        start: startDate,
        end: endDate,
        dockId: breakItem.IDDock,
        dockName: dockInfo.dockName || "",
        dockColor: dockInfo.dockColor || "#e6b3cc",
        event_id: breakItem.IDDockBreak,
      };
    });

    const breaks = formattedBreaks.map(b => ({
      ...b,
      segment: {
        start: b.start,
        end: b.end,
        dockId: b.dockId,
        dockName: b.dockName,
        Description: b.Description,
        dockColor: b.dockColor,
        IDDockBreak: b.IDDockBreak,
        sunday: b.sunday,
        monday: b.monday,
        tuesday: b.tuesday,
        wednesday: b.wednesday,
        thursday: b.thursday,
        friday: b.friday,
        saturday: b.saturday
      }
    }));

    breaks.sort((a, b) => a.start - b.start);

    const groups = [];

    for (const curr of breaks) {
      let group = groups.find(g => g.start.getTime() === curr.start.getTime());

      if (!group) {
        group = {
          start: curr.start,
          end: curr.end,
          segments: []
        };
        groups.push(group);
      }

      const alreadyAdded = group.segments.some(
        s => s.IDDockBreak === curr.segment.IDDockBreak
      );

      if (!alreadyAdded) {
        group.segments.push(curr.segment);
      }
      
      group.end = new Date(Math.max(group.end, curr.end));
    }

    for (const group of groups) {
      for (const b of breaks) {
        const overlaps = b.start < group.end && b.end > group.start;

        const existsInAnyGroup = groups.some(g =>
          g.segments.some(s => s.IDDockBreak === b.segment.IDDockBreak)
        );

        if (overlaps && !existsInAnyGroup) {
          group.segments.push(b.segment);
        }
      }
    }

    return groups;
  };

  /**
   * Function to get leave based on date and dock selected
   * @param {*} date 
   * @returns 
   */
  const getIsClosedToday=(date) => {
    let finalLeave=[]
    if (dockLeavesList.length) {
      finalLeave=dockLeavesList.filter((el)=>{
        const leaveStart = convertToJSDate(moment(el.LeaveStart).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getTime();
        const leaveEnd = convertToJSDate(moment(el.LeaveEnd).utc().format(AppConstant.commonStrings.yyyy_mm_dd_HH_MM_ss)).getTime();
        const dateTime = date.getTime();
        return dateTime >= leaveStart && dateTime <= leaveEnd;
      })
    }
    return finalLeave
  }

    return (

      <>
        <div className="mt-3 overflow-y week-scroll" style={{maxHeight:"75vh"}}>
        <div className="TableGrid sticky-element"
        >
          <span className="rs__cell rs__time"></span>
          {daysList.map((date, i) => {
            
            return(
            <span
              key={i}
              className={`rs__cell rs__header ${isToday(date) ? "rs__today_cell" : ""} ${getNonOperationalDay(date) && 'back-closed'} ${getIsClosedToday(date).length && 'bgRed'}`}
              style={{ height: "60px" }}
            >           
                <TodayTypo
                isNonOperational={getNonOperationalDay(date)}
                isClosedToday={getIsClosedToday(date)}
                  date={date}
                  locale={locale}
                />
            </span>
          )})}
        </div>
        <div className="TableGrid">
          {hours.map((h, i) => (
            <Fragment key={i}>
              <span className={`rs__cell `}>
              <Hour
              CELL_HEIGHT={CELL_HEIGHT}
              h={h}
              hFormat={hFormat}
              locale={locale}
              />
              </span>
              {daysList.map((date, ii) => {
                const start = new Date(`${format(date, "yyyy/MM/dd")} ${format(h, hFormat)}`);
                const end = addMinutes(start, step);
                return (
                  <span key={ii} className={`rs__cell ${isToday(date) ? "rs__today_cell" : ""}`}>
                    {i === 0 && (
                      <div className="d-flex" style={{position:"relative"}}>
                      <TodayEvents
                        todayEvents={events}
                        today={date}
                        minuteHeight={MINUTE_HEIGHT}
                        startHour={startHour}
                        step={step}
                      />
                      <TodayBreaks
                        todayBreaks={getBreaksForDay(date)}
                        today={date}
                        startHour={startHour}
                        step={step}
                        minuteHeight={MINUTE_HEIGHT}
                        selectedDock={selectedDock}
                        whMetaDocksList={whMetaDocksList}
                        dockList={dockList}
                        showScheduleModal={showScheduleModal}
                        setShowScheduleModal={setShowScheduleModal}
                      />
                      </div>
                    )}
                    <Cell
                      start={start}
                      end={end}
                      day={date}
                      height={CELL_HEIGHT}
                      editable={true}
                      isClosedToday={getIsClosedToday(date)}
                     showScheduleModal={showScheduleModal}
                     setShowScheduleModal={setShowScheduleModal}
                    />
                  </span>
                );
              })}
            </Fragment>
          ))}
        </div>
        </div>
      </>
    );
  };



export default Week ;
